import { Component, Inject, LOCALE_ID } from '@angular/core';
import { ResponsiveDirective } from 'projects/qo-commons/src/directives/responsive';
import { MetaTagsService } from 'projects/qo-commons/src/services/meta-tags/meta-tags.service';
import { EventType } from 'src/app/core/models/EventType';
import { CustomerStoryComponent } from 'src/app/shared/components/customer-story/customer-story.component';
import { PosterListComponent } from 'src/app/shared/components/poster-list/poster-list.component';
import { TryAndBookComponent } from 'src/app/shared/components/try-and-book/try-and-book.component';

@Component({
    templateUrl: './recruit.component.html',
    imports: [PosterListComponent, TryAndBookComponent, CustomerStoryComponent, ResponsiveDirective]
})
export class RecruitComponent {
  assetsPath = "assets/images/qoezion/recruit/";

  constructor(private metaTagsService: MetaTagsService, @Inject(LOCALE_ID) public locale: string) {}

  ngAfterViewChecked() {
      this.metaTagsService.setSeoSettings({
          title: $localize`Simplifier le recrutement des équipes bénévoles `,
          description: $localize`Simplifiez votre recrutement bénévole avec Qoezion. Créez des formulaires personnalisés et suivez facilement les profils correspondant à vos besoins pour constituer votre équipe idéale.`,
          imageUrl: `assets/images/qoezion/quickoff-qoezion.${this.locale}.jpg`
      });
  }
}